module.exports = __webpack_public_path__ + "static/media/image-576.282431ed.jpg";